import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Loading from '../../../../components/common/Loading';
import CpfCnpj from '../../../../components/common/CpfCnpj';
import { Grid, TextField, Button, MenuItem } from '@mui/material';
import ORBApi from '../../../../services/ORBApi';

const ContributorsForm = (props) => {
  const [contributor, setContributor] = useState({
    name: '',
    artist_name: '',
    document: '',
    // Beneficiario + dados bancarios
    beneficiary_name: '',
    beneficiary_document: '',
    bank_code: '',
    bank_agency: '',
    bank_account: '',
    bank_account_digit: '',
    bank_account_type: '',
  });
  const [title, setTitle] = useState('');
  const [isSaving, setIsSaving] = useState(false);

  // labels com fallback (funciona mesmo antes de adicionar as chaves de traducao)
  const ft = props.form_texts || {};

  const saveErrorHandler = (ex) => {
    if (ex.response && ex.response.data['error'] === 'INVALID_DOCUMENT') {
      toast.error(props.messages.invalid_document);
    } else {
      toast.error(props.messages.failed_to_save);
    }
    setIsSaving(false);
  };

  const saveSuccessHandler = (created_contributor) => {
    toast.success(props.messages.saved_holder);
    props.onSaveContributor(created_contributor);
    return true;
  };

  const saveContributor = () => {
    if (contributor.name === '') {
      toast.warn(props.messages.required_inputs);
      return;
    }

    setIsSaving(true);
    if (props.edit_contributors) {
      ORBApi.putContributors(contributor)
        .then((data) => {
          saveSuccessHandler(data);
        })
        .catch((ex) => {
          saveErrorHandler(ex);
        });
    } else {
      ORBApi.postContributors(contributor)
        .then((data) => {
          saveSuccessHandler(data);
        })
        .catch((ex) => {
          saveErrorHandler(ex);
        });
    }
  };

  useEffect(() => {
    if (props.edit_contributors) {
      setTitle(ft.title_edit);
      // normaliza nulls -> '' para nao quebrar os inputs controlados
      const editing = { ...props.edit_contributors };
      [
        'artist_name',
        'document',
        'beneficiary_name',
        'beneficiary_document',
        'bank_code',
        'bank_agency',
        'bank_account',
        'bank_account_digit',
        'bank_account_type',
      ].forEach((f) => {
        if (editing[f] === null || editing[f] === undefined) editing[f] = '';
      });
      setContributor(editing);
    } else {
      setTitle(ft.title);
    }
  }, []);

  const setField = (field, value) =>
    setContributor({ ...contributor, [field]: value });

  return (
    <>
      <h4>{title}</h4>
      <hr />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={4}>
          <TextField
            label={ft.input_name}
            variant="outlined"
            fullWidth
            value={contributor.name || ''}
            onChange={(e) => setField('name', e.target.value.toUpperCase())}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <TextField
            label={ft.input_artist_name}
            variant="outlined"
            fullWidth
            value={contributor.artist_name || ''}
            onChange={(e) => setField('artist_name', e.target.value.toUpperCase())}
          />
        </Grid>
        <Grid item xs={12} md={4}>
          <CpfCnpj
            label={ft.input_doc}
            value={contributor.document || ''}
            onChange={(e) => setField('document', e.target.value.replace(/\D/g, ''))}
          />
        </Grid>
      </Grid>

      <h5 style={{ marginTop: '20px' }}>{ft.section_bank || 'Dados bancários'}</h5>
      <hr />
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} md={6}>
          <TextField
            label={ft.input_beneficiary_name || 'Beneficiário'}
            variant="outlined"
            fullWidth
            value={contributor.beneficiary_name || ''}
            onChange={(e) => setField('beneficiary_name', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <CpfCnpj
            label={ft.input_beneficiary_document || 'CPF ou CNPJ do beneficiário'}
            value={contributor.beneficiary_document || ''}
            onChange={(e) =>
              setField('beneficiary_document', e.target.value.replace(/\D/g, ''))
            }
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            label={ft.input_bank || 'Banco'}
            variant="outlined"
            fullWidth
            value={contributor.bank_code || ''}
            onChange={(e) => setField('bank_code', e.target.value)}
          />
        </Grid>
        <Grid item xs={6} md={3}>
          <TextField
            label={ft.input_agency || 'Agência'}
            variant="outlined"
            fullWidth
            value={contributor.bank_agency || ''}
            onChange={(e) => setField('bank_agency', e.target.value)}
          />
        </Grid>
        <Grid item xs={6} md={2}>
          <TextField
            label={ft.input_account || 'Conta'}
            variant="outlined"
            fullWidth
            value={contributor.bank_account || ''}
            onChange={(e) => setField('bank_account', e.target.value)}
          />
        </Grid>
        <Grid item xs={6} md={1}>
          <TextField
            label={ft.input_account_digit || 'Dígito'}
            variant="outlined"
            fullWidth
            value={contributor.bank_account_digit || ''}
            onChange={(e) => setField('bank_account_digit', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            select
            label={ft.input_account_type || 'Tipo de conta'}
            variant="outlined"
            fullWidth
            value={contributor.bank_account_type || ''}
            onChange={(e) => setField('bank_account_type', e.target.value)}
          >
            <MenuItem value="">{ft.account_type_none || '—'}</MenuItem>
            <MenuItem value="Corrente">{ft.account_type_checking || 'Corrente'}</MenuItem>
            <MenuItem value="Poupanca">{ft.account_type_savings || 'Poupança'}</MenuItem>
          </TextField>
        </Grid>
      </Grid>

      <Grid item xs={12} md={3} style={{ marginTop: '15px' }}>
        {!isSaving ? (
          <Button
            variant="contained"
            color="secondary"
            size="large"
            fullWidth
            onClick={saveContributor}
          >
            {props.edit_contributors ? ft.edit_button : ft.save_button}
          </Button>
        ) : (
          <Loading />
        )}
      </Grid>
    </>
  );
};

export default ContributorsForm;
